import React from 'react';

import Slot from '../../Slot';
import IssuedInvoicesOnTerminalChart from '../../Charts/IssuedInvoicesOnTerminalChart';
import { dotToComma } from '../../../util/helperFunctions';

import './styles.css';

class IssuedInvoicesOnTerminal extends React.Component {
  render() {
    const {
      tons, invoices, late, onTime, theme,
    } = this.props;

    return (
      <div className="TwoLinesContent__root">
        <div className="TwoLinesContent__flex__row">
          <Slot
            theme={theme}
            label="Toneladas no terminal"
            value={`${dotToComma(tons)} ton`}
            separator
            verticalSeparator
          />
          <Slot
            theme={theme}
            label="Notas fiscais no terminal"
            value={invoices}
            separator
          />
        </div>
        <Slot empty>
          <div className="IssuedInvoicesOnTerminal__Chart__Container">
            <IssuedInvoicesOnTerminalChart
              late={late.value}
              onTime={onTime.value}
            />
            <div className="IssuedInvoicesOnTerminal__Flex__Row">
              <div className="IssuedInvoicesOnTerminal__Flex__Col">
                <span className="IssuedInvoicesOnTerminal__Value IssuedInvoicesOnTerminal__Late">
                  {late.value} <small>({late.percentage}%)</small>
                </span>
                <span className="IssuedInvoicesOnTerminal__Label">
                  Notas fiscais atrasadas
                </span>
              </div>
              <div className="IssuedInvoicesOnTerminal__Flex__Col IssuedInvoicesOnTerminal__Align__Right">
                <span className="IssuedInvoicesOnTerminal__Value IssuedInvoicesOnTerminal__onTime">
                  {onTime.value} <small>({onTime.percentage}%)</small>
                </span>
                <span className="IssuedInvoicesOnTerminal__Label">
                  Notas fiscais no prazo
                </span>
              </div>
            </div>
          </div>
        </Slot>
      </div>
    );
  }
}

export default IssuedInvoicesOnTerminal;
